(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8102,4693],{

/***/ 82563:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/evaluation/[evaluationId]",
      function () {
        return __webpack_require__(45217);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 28928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48641);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var design_system_components_Logo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48534);
/* harmony import */ var src_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52269);
/* harmony import */ var src_utils_getNameProp__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44873);
/* eslint-disable react/no-unused-prop-types */ /* eslint-disable react/destructuring-assignment */ 







var Template = function(props) {
    var ref, ref1;
    var children = react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(props.children).filter(react__WEBPACK_IMPORTED_MODULE_0__.isValidElement);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        justifyContent: "center",
        position: "sticky",
        top: 0,
        zIndex: 11,
        bgColor: src_colors__WEBPACK_IMPORTED_MODULE_2__/* .colors.white.off */ .O.white.off,
        p: [
            4,
            null,
            6
        ],
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.15)",
        alignItems: "center"
    }, (0,src_utils_getNameProp__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("template-header")), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                width: "40px",
                as: "button",
                ml: [
                    0,
                    8
                ]
            }, (0,src_utils_getNameProp__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("template-header-children-left")), {
                children: (ref = children.find(function(child) {
                    return child.type === Left;
                })) === null || ref === void 0 ? void 0 : ref.props.children
            })),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                flex: "1",
                justifyContent: "center"
            }, (0,src_utils_getNameProp__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("template-header-logo")), {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(design_system_components_Logo__WEBPACK_IMPORTED_MODULE_1__/* .Logo */ .T, {
                    isClickable: props === null || props === void 0 ? void 0 : props.isClickable,
                    customClick: props.customLogoClick,
                    rediectToWebFlow: props.redirectToWebFlowWhenNotAuth
                })
            })),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                width: "40px",
                justifyContent: "flex-end",
                mr: [
                    0,
                    8
                ]
            }, (0,src_utils_getNameProp__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("template-header-children-right")), {
                children: (ref1 = children.find(function(child) {
                    return child.type === Right;
                })) === null || ref1 === void 0 ? void 0 : ref1.props.children
            }))
        ]
    }));
};
var Left = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .Fragment */ .HY, {
        children: children
    });
};
var Right = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .Fragment */ .HY, {
        children: children
    });
};
var Header = Object.assign(Template, {
    Left: Left,
    Right: Right
});


/***/ }),

/***/ 84693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Loading_WholePageLoading; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
;// CONCATENATED MODULE: ./design_system/icons/SpinnerIcon.tsx




var SvgSpinnerIcon = function(_param) {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 40 : _size, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        width: size,
        height: size,
        viewBox: "0 0 2400 2400",
        id: "svg-wrapper",
        transform: "scale(".concat(size / 40, ")")
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fill: "none",
            stroke: color,
            strokeLinecap: "round",
            strokeWidth: 200,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M1200 600V100"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M1200 2300v-500",
                    opacity: 0.5
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "m900 680.4-250-433",
                    opacity: 0.917
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "m1750 2152.6-250-433",
                    opacity: 0.417
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "m680.4 900-433-250",
                    opacity: 0.833
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "m2152.6 1750-433-250",
                    opacity: 0.333
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M600 1200H100",
                    opacity: 0.75
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M2300 1200h-500",
                    opacity: 0.25
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "m680.4 1500-433 250",
                    opacity: 0.667
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "m2152.6 650-433 250",
                    opacity: 0.167
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "m900 1719.6-250 433",
                    opacity: 0.583
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "m1750 247.4-250 433",
                    opacity: 0.083
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("animateTransform", {
                    attributeName: "transform",
                    attributeType: "XML",
                    begin: "0s",
                    calcMode: "discrete",
                    dur: "1s",
                    keyTimes: "0;0.08333;0.16667;0.25;0.33333;0.41667;0.5;0.58333;0.66667;0.75;0.83333;0.91667",
                    repeatCount: "indefinite",
                    type: "rotate",
                    values: "0 1199 1199;30 1199 1199;60 1199 1199;90 1199 1199;120 1199 1199;150 1199 1199;180 1199 1199;210 1199 1199;240 1199 1199;270 1199 1199;300 1199 1199;330 1199 1199"
                })
            ]
        })
    }));
};
/* harmony default export */ var SpinnerIcon = (SvgSpinnerIcon);

// EXTERNAL MODULE: ./src/colors.ts
var colors = __webpack_require__(52269);
;// CONCATENATED MODULE: ./design_system/components/Loading/Loading.tsx







var Loading = function(_param) {
    var size = _param.size, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "size"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        w: "100%",
        height: "100%",
        justifyContent: "center",
        alignItems: "center",
        zIndex: "100",
        bg: "transparent",
        id: "loading"
    }, rest), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SpinnerIcon, {
            size: size,
            color: colors/* colors.orange.400 */.O.orange[400]
        })
    }));
};

;// CONCATENATED MODULE: ./design_system/components/Loading/index.ts


;// CONCATENATED MODULE: ./components/Loading/WholePageLoading.tsx


var WholePageLoading = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loading, {
        size: 61,
        h: "100vh"
    });
};
/* harmony default export */ var Loading_WholePageLoading = (WholePageLoading);


/***/ }),

/***/ 14262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gb": function() { return /* reexport */ Loading; },
  "Aj": function() { return /* reexport */ Loading_LoadingProgress; },
  "ok": function() { return /* reexport */ WholePageLoading["default"]; },
  "Ul": function() { return /* reexport */ Loading_WholePageProgress; }
});

// EXTERNAL MODULE: ./components/Loading/WholePageLoading.tsx + 3 modules
var WholePageLoading = __webpack_require__(84693);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/progress/dist/index.esm.js
var dist_index_esm = __webpack_require__(51943);
;// CONCATENATED MODULE: ./components/Loading/LoadingProgress.tsx


// TODO: remove when we have DS for loading
var LoadingProgress = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
        w: "100%",
        h: "100%",
        position: "absolute",
        zIndex: 1000,
        left: 0,
        justifyContent: "center",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                position: "absolute",
                backgroundColor: "#ffffff",
                opacity: 0.6,
                zIndex: 1,
                width: "100%",
                height: "100%"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist_index_esm/* CircularProgress */.D8, {
                isIndeterminate: true,
                color: "primary.500",
                position: "absolute",
                zIndex: 2,
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)"
            })
        ]
    });
};
/* harmony default export */ var Loading_LoadingProgress = (LoadingProgress);

// EXTERNAL MODULE: ./src/colors.ts
var colors = __webpack_require__(52269);
;// CONCATENATED MODULE: ./components/Loading/WholePageProgress.tsx



// TODO: remove when use DS
var WholePageProgress = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
        w: "100vw",
        h: "100vh",
        id: "page-progress",
        position: "fixed",
        zIndex: 1000,
        left: 0,
        top: 0,
        justifyContent: "center",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                position: "absolute",
                backgroundColor: colors/* colors.white.default */.O.white["default"],
                opacity: 0.6,
                zIndex: 1,
                width: "100%",
                height: "100%"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist_index_esm/* CircularProgress */.D8, {
                isIndeterminate: true,
                color: "primary.500",
                position: "absolute",
                zIndex: 2,
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)"
            })
        ]
    });
};
/* harmony default export */ var Loading_WholePageProgress = (WholePageProgress);

// EXTERNAL MODULE: ./node_modules/react-spinners/index.js
var react_spinners = __webpack_require__(74040);
;// CONCATENATED MODULE: ./components/Loading/Loading.tsx



var Loading = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Flex */.kC, {
        position: "absolute",
        w: "100%",
        height: "100%",
        top: "0",
        left: "0",
        justify: "center",
        alignItems: "center",
        zIndex: "100",
        bg: "transparent",
        id: "loading",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Flex */.kC, {
            justify: "center",
            alignItems: "center",
            position: "relative",
            bg: "rgba(0,0,0,0.1)",
            width: "100px",
            height: "100px",
            borderRadius: "10px",
            boxShadow: "lg",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_spinners.CircleLoader, {
                color: "#5383ff",
                loading: true,
                size: "50px"
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/Loading/index.ts






/***/ }),

/***/ 7206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* reexport */ NavigationBar; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./components/Header/index.tsx
var Header = __webpack_require__(28928);
// EXTERNAL MODULE: ./design_system/components/IconButton/index.ts + 2 modules
var IconButton = __webpack_require__(95892);
// EXTERNAL MODULE: ./design_system/icons/ArrowLeftIcon.tsx
var ArrowLeftIcon = __webpack_require__(66504);
;// CONCATENATED MODULE: ./components/NavigationBar/NavigationBar.tsx




var NavigationBar = function(param) {
    var onClickBack = param.onClickBack, hideHeaderLeft = param.hideHeaderLeft, isClickable = param.isClickable, customLogoClick = param.customLogoClick, redirectToWebFlowWhenNotAuth = param.redirectToWebFlowWhenNotAuth;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header/* Header */.h, {
        isClickable: isClickable,
        customLogoClick: customLogoClick,
        redirectToWebFlowWhenNotAuth: redirectToWebFlowWhenNotAuth,
        children: !hideHeaderLeft && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header/* Header.Left */.h.Left, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* OFIconButton */.d, {
                variant: "roundedPrimary",
                icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowLeftIcon/* default */.Z, {
                    size: 32
                }),
                onClick: onClickBack
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/NavigationBar/index.ts



/***/ }),

/***/ 37515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);
/* harmony import */ var _chakra_ui_icons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(28485);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47741);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(24198);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_swipeable_views__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77314);
/* harmony import */ var react_swipeable_views_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42850);
/* harmony import */ var timers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(602);
/* harmony import */ var timers__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(timers__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var src_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18467);
/* eslint-disable react/no-array-index-key */ /* eslint-disable @typescript-eslint/ban-ts-comment */ // @ts-nocheck












var Swipeable = function(_param) {
    var _showPercent = _param.showPercent, showPercent = _showPercent === void 0 ? true : _showPercent, _showSlider = _param.showSlider, showSlider = _showSlider === void 0 ? false : _showSlider, _itemsToShow = _param.itemsToShow, itemsToShow = _itemsToShow === void 0 ? 1 : _itemsToShow, children = _param.children, _spacing = _param.spacing, spacing = _spacing === void 0 ? 2 : _spacing, _isAuto = _param.isAuto, isAuto = _isAuto === void 0 ? false : _isAuto, _isDirection = _param.isDirection, isDirection = _isDirection === void 0 ? false : _isDirection, _customSliderDotProps = _param.customSliderDotProps, customSliderDotProps = _customSliderDotProps === void 0 ? function() {
        return null;
    } : _customSliderDotProps, _customSliderProps = _param.customSliderProps, customSliderProps = _customSliderProps === void 0 ? {} : _customSliderProps, _customNextButtonProps = _param.customNextButtonProps, customNextButtonProps = _customNextButtonProps === void 0 ? {} : _customNextButtonProps, _customPrevButtonProps = _param.customPrevButtonProps, customPrevButtonProps = _customPrevButtonProps === void 0 ? {} : _customPrevButtonProps, wrapperStyle = _param.wrapperStyle, _dotColor = _param.dotColor, dotColor = _dotColor === void 0 ? "primary.300" : _dotColor, _isManualAuto = _param.isManualAuto, isManualAuto = _isManualAuto === void 0 ? false : _isManualAuto, _isDirectionButtonsOverlap = _param.isDirectionButtonsOverlap, isDirectionButtonsOverlap = _isDirectionButtonsOverlap === void 0 ? false : _isDirectionButtonsOverlap, activeIdx = _param.activeIdx, callbackFunc = _param.callbackFunc, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "showPercent",
        "showSlider",
        "itemsToShow",
        "children",
        "spacing",
        "isAuto",
        "isDirection",
        "customSliderDotProps",
        "customSliderProps",
        "customNextButtonProps",
        "customPrevButtonProps",
        "wrapperStyle",
        "dotColor",
        "isManualAuto",
        "isDirectionButtonsOverlap",
        "activeIdx",
        "callbackFunc"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(20), percent = ref[0], setPercent = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), activeIndex = ref1[0], setActiveIndex = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var index = Math.floor(activeIdx / itemsToShow);
        var timeout = index === activeIndex ? 0 : 800;
        if (activeIdx || activeIdx === 0) {
            setActiveIndex(index);
            (0,timers__WEBPACK_IMPORTED_MODULE_4__.setTimeout)(callbackFunc, timeout);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        activeIdx
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setPercent(itemsToShow * (activeIndex + 1) * 100 / 5);
    }, [
        activeIndex,
        itemsToShow
    ]);
    (0,src_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useInterval */ .Yz)(function() {
        if (isManualAuto) // eslint-disable-next-line no-unsafe-optional-chaining
        setActiveIndex(function(currentActiveIndex) {
            return currentActiveIndex === (pages === null || pages === void 0 ? void 0 : pages.length) - 1 ? 0 : currentActiveIndex + 1;
        });
    }, 3000);
    if (!children) return null;
    if (!lodash__WEBPACK_IMPORTED_MODULE_0___default().isArray(children)) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Flex */ .kC, {
            width: "100%",
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                flex: "1",
                children: children
            })
        });
    }
    var pages = lodash__WEBPACK_IMPORTED_MODULE_0___default().chunk(children, itemsToShow);
    var MainSwipeable = isAuto ? (0,react_swipeable_views_utils__WEBPACK_IMPORTED_MODULE_3__/* .autoPlay */ .bH)(react_swipeable_views__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP) : react_swipeable_views__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP;
    var handleChangeSlide = function(direction) {
        if (direction === "prev" && activeIndex > 0) {
            setActiveIndex(activeIndex - 1);
        }
        if (direction === "next" && pages.length > activeIndex + 1) {
            setActiveIndex(activeIndex + 1);
        }
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
        position: "relative"
    }, props), {
        children: [
            isDirection && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Button */ .zx, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                        className: "nextSwipeable",
                        position: "absolute",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                        top: [
                            "calc(50% - 11px)",
                            "calc(50% - 12px)"
                        ],
                        right: isDirectionButtonsOverlap ? "-30px" : [
                            "0",
                            "-48px"
                        ],
                        zIndex: "1",
                        background: "white",
                        color: "primary.500",
                        _hover: {
                            color: "primaryTwo.500",
                            background: "white"
                        },
                        fontSize: [
                            "22px",
                            "24px"
                        ],
                        borderRadius: "50%",
                        width: [
                            "35px",
                            "37px"
                        ]
                    }, customNextButtonProps), {
                        onClick: function() {
                            return handleChangeSlide("next");
                        },
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_chakra_ui_icons__WEBPACK_IMPORTED_MODULE_12__/* .ChevronRightIcon */ .XC, {})
                    })),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Button */ .zx, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                        className: "prevSwipeable",
                        position: "absolute",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                        top: [
                            "calc(50% - 11px)",
                            "calc(50% - 12px)"
                        ],
                        left: isDirectionButtonsOverlap ? "-30px" : [
                            "0",
                            "-48px"
                        ],
                        zIndex: "1",
                        background: "white",
                        color: "primary.500",
                        _hover: {
                            color: "primaryTwo.500",
                            background: "white"
                        },
                        fontSize: [
                            "22px",
                            "24px"
                        ],
                        borderRadius: "50%",
                        width: [
                            "35px",
                            "37px"
                        ]
                    }, customPrevButtonProps), {
                        onClick: function() {
                            return handleChangeSlide("prev");
                        },
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_chakra_ui_icons__WEBPACK_IMPORTED_MODULE_12__/* .ChevronLeftIcon */ .wy, {})
                    }))
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, wrapperStyle), {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(MainSwipeable, {
                        index: activeIndex,
                        onChangeIndex: setActiveIndex,
                        enableMouseEvents: !activeIdx && activeIdx !== 0,
                        slideStyle: {
                            backgroundColor: "default.100",
                            border: 0,
                            boxShadow: "none",
                            paddingBottom: 10
                        },
                        style: {
                            backgroundColor: "default.100"
                        },
                        springConfig: {
                            duration: "0.8s",
                            easeFunction: "cubic-bezier(0.15, 0.3, 0.25, 1)",
                            delay: "0s"
                        },
                        children: pages.map(function(d, pi) {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Grid */ .rj, {
                                templateColumns: "repeat(".concat(itemsToShow, ", 1fr)"),
                                children: d.map(function(item, index) {
                                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .GridItem */ .P4, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                                            mr: index !== d.length - 1 ? spacing / 2 : 0,
                                            ml: index !== 0 ? spacing / 2 : 0,
                                            h: "100%",
                                            children: item
                                        })
                                    }, "grid-item-".concat(index.toLocaleString()));
                                })
                            }, pi);
                        })
                    }),
                    showPercent && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                        className: "hide-sm",
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .Slider */ .iR, {
                            "aria-label": "slider-ex-4",
                            defaultValue: 30,
                            value: percent,
                            size: "md",
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .SliderTrack */ .Uj, {
                                bg: "default.200",
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .SliderFilledTrack */ .Ms, {
                                    bg: "primary.500"
                                })
                            })
                        })
                    }),
                    showSlider && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .HStack */ .Ug, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                        justify: "center",
                        spacing: "2",
                        mt: "8"
                    }, customSliderProps), {
                        children: pages.map(function(d, i) {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Circle */ .Cd, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                                opacity: i === activeIndex ? 1 : 0.5,
                                w: 2,
                                h: 2,
                                cursor: "pointer",
                                bg: dotColor
                            }, customSliderDotProps(i, activeIndex)), {
                                onClick: function() {
                                    return setActiveIndex(i);
                                }
                            }), "testimonials_evals_".concat(i));
                        })
                    }))
                ]
            }))
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Swipeable);


/***/ }),

/***/ 66504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);




var SvgArrowLeftIcon = function(_param) {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 40 : _size, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: 40,
        height: 40,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        id: "svg-wrapper",
        transform: "scale(".concat(size / 40, ")"),
        style: {
            WebkitTransform: "scale(".concat(size / 40, ")")
        }
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
            d: "M30.955 17.633H17.98a3.614 3.614 0 0 0-.4-.483 4.005 4.005 0 0 0-.467-.392l3.7-3.7c.2-.2.2-.525 0-.725L18.63 10.15c-.2-.2-.525-.2-.725 0L8.72 19.333c-.2.2-.2.525 0 .725l9.184 9.184c.2.2.525.2.725 0l2.183-2.184c.2-.2.2-.525 0-.725l-3.7-3.7c.167-.116.325-.241.467-.391.15-.15.283-.317.4-.484h12.975a.52.52 0 0 0 .516-.516V18.15a.52.52 0 0 0-.516-.517Z",
            fill: color || "#595959"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowLeftIcon);


/***/ }),

/***/ 62762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);




var SvgClockIcon = function(_param) {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 40 : _size, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: 40,
        height: 40,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        id: "svg-wrapper",
        transform: "scale(".concat(size / 40, ")"),
        style: {
            WebkitTransform: "scale(".concat(size / 40, ")")
        }
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
            d: "M20 4C11.161 4 4 11.161 4 20s7.161 16 16 16 16-7.161 16-16S28.839 4 20 4Zm6.108 17.076-5.518 2.337a.483.483 0 0 1-.451-.046l-1.516-1.007a.483.483 0 0 1-.208-.393v-9.695a.47.47 0 0 1 .474-.475h2.21a.47.47 0 0 1 .474.475v7.3l3.31-1.412a.476.476 0 0 1 .624.255l.856 2.048a.476.476 0 0 1-.255.624v-.011Z",
            fill: color || "#595959"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgClockIcon);


/***/ }),

/***/ 45217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _evaluationId_; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Loading/index.ts + 3 modules
var Loading = __webpack_require__(14262);
// EXTERNAL MODULE: ./src/hooks/index.ts + 13 modules
var hooks = __webpack_require__(18467);
// EXTERNAL MODULE: ./src/utils/checkCountry.ts
var checkCountry = __webpack_require__(42304);
// EXTERNAL MODULE: ./graphql/generated.ts
var generated = __webpack_require__(12705);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./components/NavigationBar/index.ts + 1 modules
var NavigationBar = __webpack_require__(7206);
// EXTERNAL MODULE: ./design_system/components/OFText/index.ts
var OFText = __webpack_require__(92757);
// EXTERNAL MODULE: ./src/colors.ts
var colors = __webpack_require__(52269);
// EXTERNAL MODULE: ./src/dataTracking/events.ts
var events = __webpack_require__(26346);
// EXTERNAL MODULE: ./src/hooks/useTrackPageEvent.ts
var useTrackPageEvent = __webpack_require__(15731);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 29 modules
var es = __webpack_require__(1922);
// EXTERNAL MODULE: ./components/HaveAccountFooter.tsx
var HaveAccountFooter = __webpack_require__(61282);
// EXTERNAL MODULE: ./design_system/components/OFButton/index.ts + 3 modules
var OFButton = __webpack_require__(63773);
;// CONCATENATED MODULE: ./components/EvaluationFlow/GetStarted/CompleteYourHelpProfile.tsx







var CompleteYourHelpProfile = function(param) {
    var onClick = param.onClick;
    var t = (0,es/* useTranslation */.$G)("evaluation").t;
    var isGuest = (0,hooks/* useCheckPatientLogIn */.de)().isGuest;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFButton/* FixedButtonsWrapper */.MK, {
        bothViewport: true,
        bg: colors/* colors.green.900 */.O.green[900],
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
            flexDir: [
                "column",
                "row"
            ],
            gap: 3,
            align: "center",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFButton/* OFButton */.Vu, {
                    textTransform: "capitalize",
                    onClick: onClick,
                    children: t("get-started.action")
                }),
                isGuest && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HaveAccountFooter/* default */.Z, {
                    theme: "dark"
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var dist_index_esm = __webpack_require__(51469);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/image/dist/index.esm.js
var image_dist_index_esm = __webpack_require__(23887);
;// CONCATENATED MODULE: ./components/EvaluationFlow/GetStarted/GetStartedCard.tsx






var GetStartedCard = function(param) {
    var srcImage = param.srcImage, title = param.title, subTitle = param.subTitle, description = param.description, index = param.index, highlight = param.highlight, _showDashLine = param.showDashLine, showDashLine = _showDashLine === void 0 ? true : _showDashLine;
    var isMobile = (0,dist_index_esm/* useBreakpointValue */.Sx)({
        base: true,
        md: false
    });
    var textColor = highlight ? colors/* colors.white.default */.O.white["default"] : colors/* colors.black.900 */.O.black[900];
    var bgColor = highlight ? colors/* colors.orange.400 */.O.orange[400] : colors/* colors.white.default */.O.white["default"];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        flexDirection: "column",
        position: "relative",
        pb: [
            "24px",
            "32px"
        ],
        pl: [
            "40px",
            "56px"
        ]
    }, showDashLine && {
        _before: {
            position: "absolute",
            content: '""',
            display: "flex",
            left: isMobile ? "16px" : "28px",
            top: 0,
            height: "100%",
            width: "1px",
            borderWidth: "1px",
            background: "red",
            borderStyle: "dashed"
        }
    }), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
            flexDirection: "column",
            background: bgColor,
            padding: [
                "12px",
                "20px"
            ],
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Flex */.kC, {
                            position: "absolute",
                            top: "0",
                            zIndex: 1,
                            left: isMobile ? 0 : "8.5px",
                            width: [
                                "32px",
                                "40px"
                            ],
                            height: [
                                "32px",
                                "40px"
                            ],
                            justifyContent: "center",
                            alignItems: "center",
                            border: "solid 1px ".concat(colors/* colors.orange.400 */.O.orange[400]),
                            borderRadius: "50%",
                            backgroundColor: bgColor,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                                textStyle: "body1semibold",
                                color: highlight ? colors/* colors.white.default */.O.white["default"] : colors/* colors.orange.400 */.O.orange[400],
                                children: index
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(image_dist_index_esm/* Image */.Ee, {
                            borderRadius: "8px",
                            src: srcImage,
                            width: [
                                "100px",
                                "160px"
                            ],
                            height: [
                                "100px",
                                "160px"
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                            flexDirection: "column",
                            marginLeft: [
                                "12px",
                                "11.5px"
                            ],
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                                    color: textColor,
                                    textStyle: "h5",
                                    children: title
                                }),
                                subTitle,
                                !isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                                    textStyle: "body2",
                                    color: textColor,
                                    marginTop: [
                                        "9px",
                                        "13px"
                                    ],
                                    children: description
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Flex */.kC, {
                    children: isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                        textStyle: "body2",
                        color: textColor,
                        marginTop: [
                            "9px",
                            "13px"
                        ],
                        children: description
                    })
                })
            ]
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__(52494);
// EXTERNAL MODULE: ./node_modules/react-icons/hi/index.esm.js
var hi_index_esm = __webpack_require__(53854);
// EXTERNAL MODULE: ./components/Swipeable/index.tsx
var Swipeable = __webpack_require__(37515);
;// CONCATENATED MODULE: ./components/EvaluationFlow/GetStarted/Testimonials.tsx





var Testimonials = function(param) {
    var reviews = param.reviews;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Swipeable/* default */.Z, {
        showPercent: false,
        showSlider: true,
        isAuto: true,
        maxW: "100vw",
        children: reviews.map(function(review) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                direction: "column",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Flex */.kC, {
                        align: "center",
                        mb: 4,
                        children: Array.from({
                            length: 5
                        }, function(_, i) {
                            return i;
                        }).map(function(number) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icon_dist_index_esm/* Icon */.JO, {
                                as: hi_index_esm/* HiStar */.xiv,
                                color: "evalStar",
                                fontSize: "xl"
                            }, number);
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                        maxW: [
                            "80%",
                            "4xl"
                        ],
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                            textStyle: "body2",
                            align: "center",
                            mb: 4,
                            children: review.content
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                        textStyle: "subhead1",
                        letterSpacing: "wider",
                        children: review.name.toUpperCase()
                    })
                ]
            }, review.name);
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var recoil_es = __webpack_require__(4480);
// EXTERNAL MODULE: ./design_system/icons/ClockIcon.tsx
var ClockIcon = __webpack_require__(62762);
// EXTERNAL MODULE: ./src/constants/Evaluations.ts
var Evaluations = __webpack_require__(47252);
// EXTERNAL MODULE: ./src/constants/Review.constant.ts
var Review_constant = __webpack_require__(47428);
// EXTERNAL MODULE: ./src/dataTracking/segment.ts
var segment = __webpack_require__(99324);
// EXTERNAL MODULE: ./src/states/index.ts + 11 modules
var states = __webpack_require__(64443);
;// CONCATENATED MODULE: ./components/EvaluationFlow/GetStarted/useGetStarted.tsx




















var useGetStarted = function(param) {
    var onClick = param.onClick, evaluationId = param.evaluationId;
    var addSuffixCountry = (0,hooks/* useConfig */.ZR)().addSuffixCountry;
    var t = (0,es/* useTranslation */.$G)([
        addSuffixCountry("evaluation")
    ]).t;
    var router = (0,next_router.useRouter)();
    var patientData = (0,recoil_es/* useRecoilValue */.sJ)(states/* patientState */.ao);
    var platform = (0,recoil_es/* useRecoilValue */.sJ)(states/* platformState */.QQ);
    var reviews = (0,Review_constant/* getRandomReviewContent */.Y)(platform);
    var isConsultOnly = (0,react.useMemo)(function() {
        return Evaluations/* CONSULT_ONLY_TREAMENTS.includes */.R7.includes(evaluationId);
    }, [
        evaluationId
    ]);
    var cardTexts = (0,react.useMemo)(function() {
        return t("get-started.card", {
            returnObjects: true
        });
    }, [
        t
    ]);
    var completeHealthProfileSubTitle = (0,react.useMemo)(function() {
        var ref;
        /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
            flexDirection: "row",
            alignItems: "center",
            marginTop: [
                "12px",
                "16px"
            ],
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ClockIcon/* default */.Z, {
                    color: colors/* colors.white.default */.O.white["default"],
                    size: 24
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                    textTransform: "uppercase",
                    textStyle: "subhead1",
                    color: colors/* colors.white.default */.O.white["default"],
                    marginLeft: 1,
                    children: (ref = cardTexts[0]) === null || ref === void 0 ? void 0 : ref.subTitle
                })
            ]
        });
    }, [
        cardTexts
    ]);
    var getCardImageUrl = function(index, country) {
        var suffixCountry = (0,checkCountry/* checkCountry */.d)([
            country
        ]) ? "-".concat(country) : "";
        return "/assets/evaluation/get-started-".concat(index).concat(suffixCountry, ".svg");
    };
    var cardData = (0,react.useMemo)(function() {
        var cardList = cardTexts === null || cardTexts === void 0 ? void 0 : cardTexts.reduce(function(prev, curText, cardTextIndex) {
            var curCardIndex = prev.length + 1;
            // consult only not have delivery step
            if (cardTextIndex === 2 && isConsultOnly) {
                return prev;
            }
            var subTitle = cardTextIndex === 0 ? completeHealthProfileSubTitle : curText.subTitle;
            var srcImage = getCardImageUrl(cardTextIndex + 1, cardTextIndex === 2 && generated.RegionType.Jp);
            var curStartedCard = {
                index: curCardIndex,
                title: curText.title,
                description: curText.description,
                subTitle: subTitle,
                srcImage: srcImage
            };
            return (0,_to_consumable_array/* default */.Z)(prev).concat([
                curStartedCard
            ]);
        }, []);
        cardList[0].highlight = true;
        cardList[cardList.length - 1].showDashLine = false;
        return cardList;
    }, [
        cardTexts,
        isConsultOnly,
        completeHealthProfileSubTitle
    ]);
    var start = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    onClick();
                    (0,segment/* track$ */.s)({
                        userId: patientData === null || patientData === void 0 ? void 0 : (ref = patientData.user) === null || ref === void 0 ? void 0 : ref.id,
                        event: events/* TRACKING_EVENTS_2.evaluationStarted */.er.evaluationStarted,
                        properties: {
                            platform: platform,
                            evaluation_type: evaluationId
                        }
                    });
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        evaluationId,
        onClick,
        patientData,
        platform
    ]);
    var back = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    router.back();
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        router
    ]);
    return {
        reviews: reviews,
        cardData: cardData,
        t: t,
        back: back,
        start: start
    };
};
/* harmony default export */ var GetStarted_useGetStarted = (useGetStarted);

;// CONCATENATED MODULE: ./components/EvaluationFlow/GetStarted/GetStarted.tsx













var GetStarted = function(param) {
    var evaluationId = param.evaluationId, onClick = param.onClick;
    var ref = GetStarted_useGetStarted({
        onClick: onClick,
        evaluationId: evaluationId
    }), reviews = ref.reviews, cardData = ref.cardData, start = ref.start, back = ref.back, t = ref.t;
    (0,useTrackPageEvent/* useTrackPageEvent */.sX)(events/* PageEvents.name.gettingStarted.replace */.kl.name.gettingStarted.replace("{eval_name}", evaluationId), events/* PageEvents.categories.evaluation */.kl.categories.evaluation);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationBar/* NavigationBar */.v, {
                onClickBack: back,
                redirectToWebFlowWhenNotAuth: true
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                flexDirection: "column",
                paddingBottom: [
                    "100px",
                    "100px"
                ],
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                        padding: [
                            "20px 20px 8px",
                            "0 0 8px"
                        ],
                        flexDirection: "column",
                        width: "100%",
                        maxWidth: "588px",
                        margin: "0 auto 34px",
                        borderBottom: "1px solid #F4BD98;",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                                marginBottom: [
                                    "32px",
                                    "40px"
                                ],
                                marginTop: [
                                    "24px",
                                    "40px"
                                ],
                                textStyle: "h3",
                                color: colors/* colors.black.900 */.O.black[900],
                                children: t("get-started.title")
                            }),
                            cardData.map(function(s) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GetStartedCard, {
                                    highlight: s.highlight,
                                    index: s.index,
                                    srcImage: s.srcImage,
                                    title: s.title,
                                    description: s.description,
                                    subTitle: s.subTitle,
                                    showDashLine: s.showDashLine
                                }, s.index);
                            })
                        ]
                    }),
                    !(0,checkCountry/* checkCountry */.d)([
                        generated.RegionType.Jp
                    ]) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonials, {
                        reviews: reviews
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompleteYourHelpProfile, {
                onClick: start
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/EvaluationFlow/GetStarted/index.ts


// EXTERNAL MODULE: ./src/constants/url.constants.ts
var url_constants = __webpack_require__(97479);
// EXTERNAL MODULE: ./src/utils.ts
var utils = __webpack_require__(49384);
;// CONCATENATED MODULE: ./components/EvaluationFlow/hooks/useEvaluationFlow.ts







var useEvaluationFlow = function(param) {
    var isRequiredConsultType = param.isRequiredConsultType, latestQuestionId = param.latestQuestionId, evaluationId = param.evaluationId;
    var ref = (0,react.useState)(!latestQuestionId), isShowConsultType = ref[0], setIsShowConsultType = ref[1];
    var ref1 = (0,react.useState)(false), isShowEval = ref1[0], setIsShowEval = ref1[1];
    var isGuest = (0,hooks/* useCheckPatientLogIn */.de)().isGuest;
    var ref2 = (0,react.useState)((0,utils/* checkIsCountryHaveTextConsult */.nv)() && !Evaluations/* CONSULT_ONLY_TREAMENTS.includes */.R7.includes(evaluationId) ? generated.ConsultationSessionType.Text : generated.ConsultationSessionType.Video), consultType = ref2[0], setConsultType = ref2[1];
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        if (latestQuestionId) {
            // have saved answer => show the eval and reload to the latest question
            setIsShowConsultType(false);
            setIsShowEval(true);
        } else {
            // don't have saved answer => return to the initial state
            setIsShowConsultType(false);
            setIsShowEval(false);
        }
    }, [
        latestQuestionId
    ]);
    (0,react.useEffect)(function() {
        if (isGuest) {
            router.push((0,url_constants/* URL_GUEST_EVAL_V2 */.kq)(evaluationId));
        }
    });
    var setNextEvalStep = (0,react.useCallback)(function() {
        if (isRequiredConsultType) {
            setIsShowConsultType(true);
        } else {
            setIsShowEval(true);
        }
    }, [
        isRequiredConsultType
    ]);
    var hideEvalFlow = (0,react.useCallback)(function() {
        if (isRequiredConsultType) {
            setIsShowEval(false);
        } else {
            router.push(url_constants/* URL_HOME */.MH);
        }
    }, [
        isRequiredConsultType,
        router
    ]);
    var showEvalFlow = (0,react.useCallback)(function() {
        setIsShowEval(true);
        setIsShowConsultType(false);
    }, []);
    var clickBackFromSelectConsult = (0,react.useCallback)(function() {
        setIsShowConsultType(false);
    }, []);
    return {
        isShowEval: isShowEval,
        consultType: consultType,
        isShowConsultType: isShowConsultType,
        setNextEvalStep: setNextEvalStep,
        setConsultType: setConsultType,
        setIsShowConsultType: setIsShowConsultType,
        showEvalFlow: showEvalFlow,
        hideEvalFlow: hideEvalFlow,
        clickBackFromSelectConsult: clickBackFromSelectConsult,
        isGuest: isGuest
    };
};
/* harmony default export */ var hooks_useEvaluationFlow = (useEvaluationFlow);

;// CONCATENATED MODULE: ./components/EvaluationFlow/EvaluationFlow.tsx









var Evaluation = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4617), __webpack_require__.e(7141), __webpack_require__.e(7536), __webpack_require__.e(5551), __webpack_require__.e(1285), __webpack_require__.e(833), __webpack_require__.e(2877), __webpack_require__.e(6974), __webpack_require__.e(8512), __webpack_require__.e(221), __webpack_require__.e(3751), __webpack_require__.e(1493), __webpack_require__.e(5833), __webpack_require__.e(1927), __webpack_require__.e(8795), __webpack_require__.e(9349)]).then(__webpack_require__.bind(__webpack_require__, 957)).then(function(components) {
        return components.Evaluation;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(957)
            ];
        }
    }
});
var ConsultTypeSelectorContainer = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2877), __webpack_require__.e(7616)]).then(__webpack_require__.bind(__webpack_require__, 77616)).then(function(components) {
        return components.ConsultTypeSelectorContainer;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(77616)
            ];
        }
    }
});
var EvaluationFlow = function(param) {
    var evaluationId = param.evaluationId, productId = param.productId;
    var isRequiredConsultType = (0,react.useMemo)(function() {
        return [
            generated.EvalIds.Ed,
            generated.EvalIds.Pe,
            generated.EvalIds.Hairloss,
            generated.EvalIds.WeightLoss,
            generated.EvalIds.WeightLossZoey
        ].includes(evaluationId) && (0,checkCountry/* checkCountry */.d)([
            generated.RegionType.Jp,
            generated.RegionType.Hk
        ]);
    }, [
        evaluationId
    ]);
    var ref = (0,hooks/* useGetEvaluationDataFromLocalStorageQuery */.BP)(evaluationId), localEvalData = ref.data;
    var ref1 = hooks_useEvaluationFlow({
        isRequiredConsultType: isRequiredConsultType,
        latestQuestionId: localEvalData === null || localEvalData === void 0 ? void 0 : localEvalData.latestQuestionSysId,
        evaluationId: evaluationId
    }), isShowConsultType = ref1.isShowConsultType, isShowEval = ref1.isShowEval, consultType = ref1.consultType, setNextEvalStep = ref1.setNextEvalStep, setConsultType = ref1.setConsultType, showEvalFlow = ref1.showEvalFlow, hideEvalFlow = ref1.hideEvalFlow, clickBackFromSelectConsult = ref1.clickBackFromSelectConsult, isGuest = ref1.isGuest;
    if (isGuest) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loading/* WholePageLoading */.ok, {});
    if (isShowConsultType) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ConsultTypeSelectorContainer, {
            onSelectType: setConsultType,
            consultType: consultType,
            onNextClick: showEvalFlow,
            onClickBack: clickBackFromSelectConsult,
            shouldShowMoreInit: false
        });
    }
    if (isShowEval) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Evaluation, {
            hideEvalFlow: hideEvalFlow,
            consultType: consultType,
            evaluationId: evaluationId,
            productId: productId
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GetStarted, {
        evaluationId: evaluationId,
        onClick: setNextEvalStep
    });
};

;// CONCATENATED MODULE: ./components/EvaluationFlow/index.ts


;// CONCATENATED MODULE: ./pages/evaluation/[evaluationId].tsx


var EvaluationPage = function(param) {
    var evaluationId = param.evaluationId, productId = param.productId;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EvaluationFlow, {
        evaluationId: evaluationId,
        productId: productId
    });
};
var __N_SSP = true;
/* harmony default export */ var _evaluationId_ = (EvaluationPage);


/***/ }),

/***/ 47428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ getRandomReviewContent; }
/* harmony export */ });
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76395);

var getRandomReviewContent = function(platform) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)("checkout").t;
    var reviews = t("reviews.".concat(platform), {
        returnObjects: true,
        defaultValue: []
    });
    var reviewLength = reviews.length;
    var randomNumber1 = Math.floor(Math.random() * (reviewLength - 2) + 1);
    var randomNumber2 = Math.floor(Math.random() * randomNumber1);
    var randomNumber3 = Math.floor(Math.random() * (reviewLength - randomNumber1 - 1) + randomNumber1 + 1);
    return [
        reviews[randomNumber1],
        reviews[randomNumber2],
        reviews[randomNumber3]
    ];
};


/***/ }),

/***/ 44873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var separators = /[-._/\s]+/g;
var ATTRIBUTE_NAME = "data-refname";
// THIS IS FOR QA AUTOMATION, DO NOT CHANGE NAMES WITHOUT INFORMING QA TEAM
var getNameProp = function() {
    for(var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++){
        names[_key] = arguments[_key];
    }
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, ATTRIBUTE_NAME, names.join(" ").trim().toLowerCase().replace(separators, "-"));
};
/* harmony default export */ __webpack_exports__["Z"] = (getNameProp);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,8418,329,6889,4592,5494,871,4528,7234,4443,8467,8862,9774,2888,179], function() { return __webpack_exec__(82563); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);